import { z } from "zod/v4";

/** The only validity windows the server accepts for a new link. */
export const SHARE_LINK_VALID_DAYS = [1, 7, 30] as const;
export const DEFAULT_SHARE_LINK_VALID_DAYS = 7;
export const SHARE_LINK_LABEL_MAX_LENGTH = 80;

export const shareLinkValidDaysSchema = z.union([z.literal(1), z.literal(7), z.literal(30)]);
export type ShareLinkValidDays = z.infer<typeof shareLinkValidDaysSchema>;

export const shareLinkStateSchema = z.enum(["unused", "opened", "expired", "revoked"]);
export type ShareLinkState = z.infer<typeof shareLinkStateSchema>;

export const shareLinkSchema = z.object({
	created_at: z.string(),
	expires_at: z.string(),
	id: z.string().min(1),
	label: z.string(),
	opened_at: z.string().nullable(),
	revoked_at: z.string().nullable(),
	state: shareLinkStateSchema,
});
export type ShareLink = z.infer<typeof shareLinkSchema>;

/** Both fields are optional on the wire: the server defaults them ("" and 7). */
export const createShareLinkSchema = z.object({
	label: z.string().max(SHARE_LINK_LABEL_MAX_LENGTH).optional(),
	valid_days: shareLinkValidDaysSchema.optional(),
});
export type CreateShareLink = z.infer<typeof createShareLinkSchema>;

/** `url` is returned by the create call only; the server keeps just a hash. */
export const createdShareLinkSchema = z.object({
	link: shareLinkSchema,
	url: z.string().url(),
});
export type CreatedShareLink = z.infer<typeof createdShareLinkSchema>;
